import { useState } from "react";
import genericRepositoryService from "../../../../services/genericRepositoryService";
import { IMachineTranslationRequest } from "../../../../models/IMachineTranslationRequest";

/**
 * Hook for text translation
 * Single Responsibility: Translate text from one language to another
 */
export const useTextTranslation = () => {
  const [isTranslating, setIsTranslating] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const translateText = async (
    text: string,
    fromLanguageCode: string,
    toLanguageCode: string,
  ): Promise<string | null> => {
    if (!text || !fromLanguageCode || !toLanguageCode) {
      return null;
    }

    setIsTranslating(true);
    setError(null);

    try {
      const request: IMachineTranslationRequest = {
        fromLanguageCode,
        toLanguageCode,
        textToTranslate: text,
      };

      const response = await genericRepositoryService.translateText(request);

      if (response.data.errorMessage) {
        setError(new Error(response.data.errorMessage));
        return null;
      }

      return response.data.translatedText || null;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to translate text";
      setError(new Error(errorMessage));
      console.error("Translation error:", err);
      return null;
    } finally {
      setIsTranslating(false);
    }
  };

  return {
    translateText,
    isTranslating,
    error,
  };
};
